module.exports = "<div id=\"woMain\" >\r\n  <div  id=\"woSI\">{{researchInstructions}}</div>\r\n</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/workOrderSpecialInstructions/WorkOrderSpecialInstructions.component.html
// module id = ./src/app/workOrderSpecialInstructions/WorkOrderSpecialInstructions.component.html
// module chunks = app